import config from './config';
import request from './request'
import iView from 'view-design';
import cookie from 'vue-cookies';
import md5 from 'js-md5';
import store from '../store';
import router from '../router';
import moment from 'moment';
import { Message } from 'iview'
//搜索数组对象key值的 index
export function findIndex (list, key_name, key_value) {
    return list.findIndex((v) => {
        return v[key_name] == key_value;
    });
}

//MD5
export function toMD5 (str) {
    return md5(str);
}

//设置Cookie
export function setCookie (key, value) {
    cookie.set(key, value, { path: '/', expires: config.cookie_date });
}
export function setCookieL (key, value) {
    cookie.set(key, value, { path: '/', expires: 9999 });
}
export function getCookie (key) {
    return cookie.get(key);
}
export function clearCookie (key) {
    cookie.set(key, '', { path: '/', expires: -1 });
}

//设置语言Cookie
export function setLangCookie (self, value) {
    self.$i18n.locale = value;
    setCookieL("WXYD-LANG", value);
    document.title = config.i18n._vm.messages[getLang()].sys_name;
}
export function getLang () {
    if (getCookie("WXYD-LANG")) {
        return getCookie("WXYD-LANG");
    }
    else {
        return config.langs[0].key;
    }
}

//弹框
export function alertErr (content) {
    iView.Modal.error({
        title: config.i18n._vm.messages[getLang()].op_err,
        content: content
    });
}
export function alertWarning (content) {
    iView.Modal.warning({
        title: config.i18n._vm.messages[getLang()].warning,
        content: content
    });
}
export function alertInfo (content) {
    iView.Modal.info({
        title: config.i18n._vm.messages[getLang()].tips,
        content: content
    });
}
export function alertSuccess (content) {
    iView.Modal.success({
        title: config.i18n._vm.messages[getLang()].op_ok,
        content: content
    });
}
//提示
export function msgSuccess (content) {
    iView.Message.success({
        content: content,
        duration: 5
    });
}
export function msgWarning (content) {
    iView.Message.warning({
        content: content,
        duration: 5
    });
}
export function msgErr (content) {
    iView.Message.error({
        content: content,
        duration: 8
    });
}
//选择框
export function confirm (title, content, okBack, cancelBack) {
    iView.Modal.confirm({
        title: title,
        content: content,
        onOk: () => {
            okBack();
        },
        onCancel: () => {
            if (typeof (cancelBack) == 'function') {
                cancelBack();
            }
        }
    });
}
export function alertImg (src, title, width) {
    iView.Modal.info({
        title: title,
        okText: config.i18n._vm.messages[getLang()].close,
        width: width,
        render: (h) => {
            return h('div', {
                style: {
                    textAlign: "center"
                }
            }, [
                h('img', {
                    style: {
                        width: "100%"
                    },
                    attrs: {
                        src: src
                    }
                })
            ]);
        }
    });
}
//加载中
export function showLoading () {
    iView.Spin.show();
}
export function hideLoading () {
    iView.Spin.hide();
}

//跳转
export function linkTo (path, option) {
    router.push({
        path: path,
        query: option
    });
}
export function replaceTo (path, option) {
    router.replace({
        path: path,
        query: option
    });
}
//后退
export function linkBack () {
    router.go(-1);
}
//获取连接path
export function getLinkPath () {
    return router.currentRoute.path;
}
//获取参数
export function getRequest () {
    return router.currentRoute.query;
}

//登录退出
export function setTokenCookie (data) {
    setCookie("WXYD-TOKEN-X", data.access_token);
    if (data.last_role_id == "") {
        openRole();
    }
    else {
        setRoleCookie(data);
        replaceTo("/");
    }
}
export function setRoleCookie (data) {
    setCookie("WXYD-ORG-ID", data.last_org_id);
    setCookie("WXYD-ROLE-ID", data.last_role_id);
}
export function logout () {
    clearCookie("WXYD-TOKEN-X");
    clearCookie("WXYD-ORG-ID");
    clearCookie("WXYD-ROLE-ID");
    store.dispatch("clearBaseData_MenuOpens");
    replaceTo("/login");
}
export function getToken () {
    return getCookie("WXYD-TOKEN-X");
}
export function getOrgId () {
    return getCookie("WXYD-ORG-ID");
}
export function getRoleId () {
    return getCookie("WXYD-ROLE-ID");
}
export function setOrgLevel (org_level) {
    setCookie("WXYD-ORG-LEVEL", org_level);
}
export function getOrgLevel () {
    return getCookie("WXYD-ORG-LEVEL");
}
//列出角色 jsx语法 不用理会错误信息
export function openRole () {
    showLoading();
    request.sendPost("user/role-list", {}, (success, data, error) => {
        hideLoading();
        if (success) {
            iView.Modal.info({
                title: config.i18n._vm.messages[getLang()].select_role,
                width: "500",
                okText: config.i18n._vm.messages[getLang()].cancel,
                render: function (h) {
                    return <div class={'role-box'}>
                        {
                            data.list.map(item => {
                                return [
                                    <div class='org'>{item.org_cname}：</div>,
                                    <div class='role'>
                                        {
                                            item.roles.map((role) => {
                                                return <a onClick={() => { this.$base.changeRole(role) }}>{role.role_cname}</a>
                                            })
                                        }

                                    </div>
                                ];
                            })
                        }
                    </div>;
                }
            });
        }
        else {
            alertErr(error.errmsg);
        }
    });
}
//切换角色
export function changeRole (role) {
    var data = {
        org_id: role.org_id,
        role_id: role.role_id
    };
    request.sendPost("user/upd-last-role", data, (success, data, error) => {
        if (success) {
            iView.Modal.remove();
            if (getLinkPath() != '/login') {
                setTimeout(() => {
                    store.dispatch("setBaseData_baseReload", true);
                }, 500);
            }
            setRoleCookie({ last_org_id: role.org_id, last_role_id: role.role_id });
            store.dispatch("clearBaseData_MenuOpens");
            replaceTo("/");
        }
        else {
            iView.Modal.remove();
            setTimeout(() => {
                alertErr(error.errmsg);
            }, 500);
        }
    })
}

//设置菜单切换
export function setMenuActiveName () {
    var url = getLinkPath();
    store.dispatch("setBaseData_Menu", { active_name: url });
}
//设置已开启的菜单
export function setMenuOpens () {
    var url = getLinkPath();
    store.dispatch("setBaseData_Menu", { active_name: url });
    var para = getRequest();
    if (!para.fn || para.fn == "") return;
    var data = {
        fid: para.fid,
        fn: para.fn,
        path: url,
        url: router.currentRoute.fullPath,
    };
    store.dispatch("setBaseData_MenuOpens", data);
}

//数字
export function regNum () {
    return /^[\-]{0,1}\d+(\.\d+){0,1}$/;
}

//复制对象
export function copyJson (source) {
    return JSON.parse(JSON.stringify(source));
}

//以左边(df)为标准填充 左值填充
export function leftJson (df, source) {
    var data = {};
    for (var obj in df) {
        if (source[obj]) {
            data[obj] = source[obj];
        }
        else {
            data[obj] = df[obj];
        }
    }
    return data;
}
//根据默认值替换对象 合集填充
export function extendJson (df, source) {
    var data = {};
    for (var obj in df) {
        data[obj] = df[obj];
    }
    for (var obj in source) {
        data[obj] = source[obj];
    }
    return data;
}

// json 键值互换
export function changeJsonKeyValue (ths) {
    var ss = {};
    for (var key in ths) {
        ss[ths[key]] = key;
    }
    return ss;
}

//聚焦文本框
export function inputFocus (txt) {
    setTimeout(() => {
        txt.focus();
    }, 200);
}

//设置表格高度
export function getTableBoxHeight (table_box_content) {
    var table_box_content_top = getOffsetTop(table_box_content);
    return document.body.clientHeight - table_box_content_top - 65;
}
export function getOffsetTop (el) {
    return el.offsetParent
        ? el.offsetTop + getOffsetTop(el.offsetParent)
        : el.offsetTop
}
export function setTableBoxContentScroll (self, is_fixed = true) {
    self.$refs['table_box_header'].scrollLeft = self.$refs['table_box_content'].scrollLeft;
    if (is_fixed) {
        self.$refs['table_box_content_fixed'].scrollTop = self.$refs['table_box_content'].scrollTop;
    }
}

//获取日期快捷时间
export function getDateArea (index = null) {
    var lang = config.i18n._vm.messages[getLang()];
    var datearea = [
        {
            text: lang.custom,
            date_fr: '',
            date_to: ''
        },
        {
            text: lang.today,
            date_fr: moment().format("YYYY-MM-DD"),
            date_to: moment().format("YYYY-MM-DD")
        },
        {
            text: lang.yesterday,
            date_fr: moment().add(-1, 'days').format("YYYY-MM-DD"),
            date_to: moment().add(-1, 'days').format("YYYY-MM-DD")
        },
        {
            text: lang.curr_week,
            date_fr: moment().startOf('isoWeek').format("YYYY-MM-DD"),
            date_to: moment().endOf('isoWeek').format("YYYY-MM-DD")
        },
        {
            text: lang.before_week,
            date_fr: moment().add(-1, 'weeks').startOf('isoWeek').format("YYYY-MM-DD"),
            date_to: moment().add(-1, 'weeks').endOf('isoWeek').format("YYYY-MM-DD")
        },
        {
            text: lang.curr_month,
            date_fr: moment().startOf('month').format("YYYY-MM-DD"),
            date_to: moment().endOf('month').format("YYYY-MM-DD")
        },
        {
            text: lang.before_month,
            date_fr: moment().add(-1, 'month').startOf('month').format("YYYY-MM-DD"),
            date_to: moment().add(-1, 'month').endOf('month').format("YYYY-MM-DD")
        },
        {
            text: lang.curr_year,
            date_fr: moment().startOf('year').format("YYYY-MM-DD"),
            date_to: moment().endOf('year').format("YYYY-MM-DD")
        },
        {
            text: lang.before_year,
            date_fr: moment().add(-1, 'year').startOf('year').format("YYYY-MM-DD"),
            date_to: moment().add(-1, 'year').endOf('year').format("YYYY-MM-DD")
        },
    ];
    if (index != null) {
        return datearea[index];
    }
    else {
        return datearea;
    }
}

//获取月份快捷时间
export function getDateMonthArea (index = null) {
    var lang = config.i18n._vm.messages[getLang()];
    var datearea = [
        {
            text: lang.custom,
            date_fr: '',
            date_to: ''
        },
        {
            text: lang.curr_month,
            date_fr: moment().startOf('month').format("YYYY-MM"),
            date_to: moment().endOf('month').format("YYYY-MM")
        },
        {
            text: lang.before_month,
            date_fr: moment().add(-1, 'month').startOf('month').format("YYYY-MM"),
            date_to: moment().add(-1, 'month').endOf('month').format("YYYY-MM")
        },
        {
            text: lang.before_month3,
            date_fr: moment().add(-2, 'month').startOf('month').format("YYYY-MM"),
            date_to: moment().endOf('month').format("YYYY-MM")
        },
        {
            text: lang.before_month4,
            date_fr: moment().add(-3, 'month').startOf('month').format("YYYY-MM"),
            date_to: moment().endOf('month').format("YYYY-MM")
        },
        {
            text: lang.curr_year,
            date_fr: moment().startOf('year').format("YYYY-MM"),
            date_to: moment().endOf('year').format("YYYY-MM")
        },
        {
            text: lang.before_year,
            date_fr: moment().add(-1, 'year').startOf('year').format("YYYY-MM"),
            date_to: moment().add(-1, 'year').endOf('year').format("YYYY-MM")
        },
    ];
    if (index != null) {
        return datearea[index];
    }
    else {
        return datearea;
    }
}

//获取未来日期快捷时间
export function getFutrueDateArea (index = null) {
    var lang = config.i18n._vm.messages[getLang()];
    var datearea = [
        {
            text: lang.custom,
            date_fr: '',
            date_to: ''
        },
        {
            text: lang.today,
            date_fr: moment().format("YYYY-MM-DD"),
            date_to: moment().format("YYYY-MM-DD")
        },
        {
            text: lang.curr_week,
            date_fr: moment().startOf('isoWeek').format("YYYY-MM-DD"),
            date_to: moment().endOf('isoWeek').format("YYYY-MM-DD")
        },
        {
            text: lang.curr_month,
            date_fr: moment().startOf('month').format("YYYY-MM-DD"),
            date_to: moment().endOf('month').format("YYYY-MM-DD")
        },
        {
            text: lang.futrue_three_month,
            date_fr: moment().add(+1, 'month').startOf('month').format("YYYY-MM-DD"),
            date_to: moment().add(+3, 'month').endOf('month').format("YYYY-MM-DD")
        },
        {
            text: lang.curr_year,
            date_fr: moment().startOf('year').format("YYYY-MM-DD"),
            date_to: moment().endOf('year').format("YYYY-MM-DD")
        },
    ];
    if (index != null) {
        return datearea[index];
    }
    else {
        return datearea;
    }
}

// 判断数据是否为空
function isArray (array) {
    return Object.prototype.toString.call(array) === '[object Array]'
}
function isObject (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]'
}
export function isEmpty (value) {
    if (value === undefined || value === '' || value === null || (isArray(value) && value.length === 0) || (isObject(value) && Object.keys(value).length === 0)) {
        return true
    } else {
        return false
    }
}

//获取扫描卡号
export function getCardNo (value) {
    if (value.trim() == "") {
        return '';
    }
    var ss = value.split('/');
    return ss[ss.length - 1];
}

// base64转File文件类型
export function base64ToFile (urlData, fileName) {
    let arr = urlData.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bytes = atob(arr[1]); // 解码base64
    let n = bytes.length
    let ia = new Uint8Array(n);
    while (n--) {
        ia[n] = bytes.charCodeAt(n);
    }
    return new File([ia], fileName, { type: mime });
}

//获取星期
export function getWeek (date) { // 参数时间戳
    var lang = config.i18n._vm.messages[getLang()];
    let week = moment(date).day();
    return lang['week' + week];
}

//导出Excel  options={excel_name:"会员列表",search:{},rows:10}
export function getExportData (self) {
    var com = config.i18n._vm.messages[getLang()];
    var rows = self.totalData.total;
    if (rows <= 0) {
        hideLoading();
        alertErr(com.search_nodata);
        return;
    }
    //手工分页导出
    var data = copyJson(self.search);
    data.page = 1;
    data.limit = config.export_limit;
    config.export_pages = Math.ceil(rows / data.limit);
    return data;
}
export function exportExcel (self) {
    var data = getExportData(self);
    if (data !== undefined) {
        seedExportExcel(self, data)
    }
}
function seedExportExcel (self, search_data) {
    var com = config.i18n._vm.messages[getLang()];
    showLoading();
    request.sendPost(search_data.search_url, search_data, (success, data, error) => {
        hideLoading();
        if (success) {
            self.excelData = data.list || data;
            self.export_title = self.title + '(' + search_data.page + '-' + parseInt(data.last_page) + ')';
            setTimeout(() => {
                self.$refs['btn_excel'].click();

                if (search_data.page < config.export_pages) {
                    setTimeout(() => {
                        search_data.page = parseInt(search_data.page) + 1;
                        seedExportExcel(self, search_data);
                    }, 800);
                }
            }, 800);
        } else {
            alertErr(error.errmsg);
        }
    });
}

//获取日历数据
export function getCalendarData (month_no) {
    var end = moment(month_no).daysInMonth();
    let row = 0;
    let col = moment(moment(month_no).format('YYYY-MM-DD')).day() - 1;
    const calendar = [[]];
    let thisDay = 1;
    while (thisDay <= end) {
        var thisDate = moment(month_no).add(thisDay, 'd').format('YYYY-MM-DD');
        if (col == 7) {
            row++;
            col = 0;
            calendar[row] = [{ day: thisDay, date: thisDate }];
        } else {
            calendar[row][col] = { day: thisDay, date: thisDate };
        }
        thisDay++;
        col++;
    }
    var last_row = calendar[calendar.length - 1];
    var add_col = 7 - last_row.length;
    for (var i = 0; i < add_col; i++) {
        last_row.push(null);
    }
    return calendar;
}

export function bodyClick () {
    document.body.click();
}

// 设置不同语言 键名前缀
export const setPrefix = (name) => {
    switch (getLang()) {
        case 'zh-CN':
            name = 'zh-cn_' + name; break;
        case 'zh-TW':
            name = 'zh-tw_' + name; break;
        case 'en':
            name = 'en_' + name; break;
    }
    return name
}
export const uploadPic = (file, path) => {
    const OSS = require("ali-oss");
    return new Promise((resolve, reject) => {
        request.sendPost('com/get-upimg-key', {}, (success, data2, error) => {
            if (success) {
                var client = new OSS({
                    region: data2.region, //地域
                    accessKeyId: data2.accessKeyId, //你自己的key和id
                    accessKeySecret: data2.accessKeySecret,
                    bucket: data2.bucket, //oss上你的存储空间名称
                    secure: true,
                })
                const uid = file.lastModified;
                const name = file.name;
                const suffix = name.substr(name.indexOf('.'));
                const fileName = Date.parse(new Date()) + '' + uid + suffix;
                // 支持File对象、Blob数据以及OSS Buffer。
                const data = file;
                const pathName = path;
                resolve(client.put(pathName + fileName, data))
            }
            else {
                reject(alertErr(this.$t("upload_err")))
            }
        })
    })
}
export const uploadPicimg = (file, path) => {
    let type = file.name.substr(file.name.lastIndexOf('.')).toLowerCase(); // .jpg
    let imgType = type.split('.')[1]; // jpg
    let imgFileTypeArr = ['jpg', 'jpeg', 'png'];
    let checkType = imgFileTypeArr.some(item => {
        return item === imgType;
    });
    if (!checkType) {
        Message.info('只支持.png .jpg .jpeg格式');
        hideLoading();
        return false;
    }
    // 文件大小校验
    // const checkMax = file.size < 10485760;
    const checkMax = file.size < 3 * 1024 * 1024;
    if (!checkMax) {
        // Message.info('单个文件不能大于10MB');
        Message.info('单个文件不能大于3MB');
        hideLoading();
        return false;
    }
    const OSS = require("ali-oss");
    return new Promise((resolve, reject) => {
        request.sendPost('com/get-upimg-key', {}, (success, data2, error) => {
            if (success) {
                var client = new OSS({
                    region: data2.region, //地域
                    accessKeyId: data2.accessKeyId, //你自己的key和id
                    // endpoint: data2.cdn,//访问域名
                    accessKeySecret: data2.accessKeySecret,
                    bucket: data2.bucket, //oss上你的存储空间名称
                    secure: true,
                })
                const uid = file.lastModified;
                const name = file.name;
                const suffix = name.substr(name.indexOf('.'));
                const fileName = Date.parse(new Date()) + '' + uid + suffix;
                // 支持File对象、Blob数据以及OSS Buffer。
                const data = file;
                const pathName = path;
                // client.put(pathName + fileName, data).then(res => {
                //     resolve({ url: data2.cdn + '/' + fileName })
                // })
                client.put(fileName, data).then(res => {
                    resolve({ url: data2.cdn + '/' + fileName })
                })
            }
            else {
                reject(alertErr(this.$t("upload_err")))
            }
        })
    })
}
export default {
    findIndex,
    toMD5,
    setLangCookie,
    getLang,
    alertErr,
    alertWarning,
    alertInfo,
    alertSuccess,
    msgErr,
    msgWarning,
    msgSuccess,
    confirm,
    alertImg,
    showLoading,
    hideLoading,
    linkTo,
    replaceTo,
    linkBack,
    getLinkPath,
    getRequest,
    setTokenCookie,
    logout,
    getToken,
    getOrgId,
    getRoleId,
    openRole,
    changeRole,
    setMenuActiveName,
    setMenuOpens,
    regNum,
    leftJson,
    extendJson,
    changeJsonKeyValue,
    getTableBoxHeight,
    getOffsetTop,
    setTableBoxContentScroll,
    getDateArea,
    getDateMonthArea,
    getFutrueDateArea,
    isEmpty,
    setOrgLevel,
    getOrgLevel,
    getCardNo,
    base64ToFile,
    getWeek,
    getExportData,
    exportExcel,
    copyJson,
    getCalendarData,
    inputFocus,
    bodyClick,
    uploadPic,
    uploadPicimg
};



// WEBPACK FOOTER //
// ./src/utils/base.js